module.exports = new __parcel__URL__("mercenary_wolvez_hideout_level_2.af03be6e.png").toString();